// extracted by mini-css-extract-plugin
export default {"loadingSec":"loading_loadingSec__7ZGe1","loadingWrapper":"loading_loadingWrapper__SygDk","loadingImage":"loading_loadingImage__mpQdX","spin":"loading_spin__mAmCv"};